import React, { useEffect, useState } from 'react';
import Authorize from '../../../components/AuthComponent/Authorize';
import SaveButton from '../../../components/Buttons/SaveButton';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import Popup from '../../../components/Popups/Popup';
import SpinnerOverlay from '../../../components/Spinner/SpinnerOverlay';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ItemSizeModel from '../../../models/ItemSizeModel';
import UserDefinedFieldModel from '../../../models/UserDefinedFieldModel';
import DataService from "../../../services/data.service";
import { Result } from '../../../types/Result';

interface IProps {
    show: boolean
    onHide: (updatedItemSizes?: ItemSizeModel[]) => void
    onDelete: (itemSizeId: number) => void
    itemTypeId: number
    itemSizes: ItemSizeModel[]
}

const ItemRevision_popup_EditItemSizes: React.FC<IProps> = ({ show, onHide, onDelete, itemTypeId, itemSizes }) => {
    const [data, setData] = useState<ItemSizeModel[]>()
    const [fields, setFields] = useState<UserDefinedFieldModel[]>()
    const [serverErrors, setServerErrors] = useState<Result[]>()
    const [showSpinner, setShowSpinner] = useState(false)
    const { handleResult, handleException } = useNotifications()
    const { isAuthorizedForItemType } = useAuth()

    useEffect(() => {
        setData(itemSizes)
        if (itemSizes && itemSizes.length > 0)
            setFields(itemSizes[0].userDefinedFields.map((field) => { return field.userDefinedField }))
    }, [itemSizes]);

    function SaveChanges() {
        if (data) {
            setShowSpinner(true)
            DataService
                .updateTableData<ItemSizeModel>(`api/v1/ItemSizes/UpdateMultiple`, data)
                .then(response => {
                    setShowSpinner(false)
                    if (response.filter(x => x.isSuccesful == false).length === 0) {
                        let items: ItemSizeModel[] = []
                        response.forEach(x => {
                            if (x.data)
                                items.push(x.data)
                        })
                        onHide(items);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function deleteRow(row: ItemSizeModel) {
        setShowSpinner(true)
        DataService
            .delete(`api/v1/ItemSizes/`, row.id)
            .then(response => {
                setShowSpinner(false)
                handleResult(response);
                if (response.isSuccesful === true) {
                    onDelete(row.id)
                }
            })
            .catch(e => handleException(e));
    }

    function onCellChange(value: any, rowIndex: number, dataProp?: string) {
        if (data && dataProp) {
            dataProp.split('.').reduce((object, propertyName, index, elements) => {
                if (index === elements.length - 1) {
                    object[propertyName] = value;
                    setData(data.slice());
                }

                if (object && object[propertyName]) {
                    return object[propertyName];
                }
                return null;
            }, data[rowIndex]);
        }
    }

    function getUserDefinedField(rowData: ItemSizeModel, colInfo: IColInfo): UserDefinedFieldModel | undefined {
        let result

        rowData.userDefinedFields.forEach((value, index) => {
            if (value.userDefinedField && value.userDefinedField.name == colInfo.title)
                result = value.userDefinedField
        })

        return result
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Size-set', dataProp: 'size.sizeSet.name' },
        { title: 'Size', dataProp: 'size.name', sortProp: 'size.sortOrder', sort: 'asc' },
    ];

    if (fields) {
        fields.forEach((field, index, array) => {
            colInfos.push({
                title: field.name,
                width: 175,
                dataProp: 'userDefinedFields.' + index + '.value',
                editable: true,
                dataType: 'userDefinedField',
                getUserDefinedField: getUserDefinedField,
            })

        })
    }

    if (isAuthorizedForItemType(ApplicationFunctions.UpdateItem, itemTypeId)) {
        colInfos.push(
            {
                //headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    if (data && fields) {
        return (
            <>
                <Popup show={show} onHide={onHide} size={'lg'} title={'Edit sizes'} >
                    <Popup.Body>
                        <DataTable key='dtItemSizes'
                            name='dtItemSizes'
                            colInfos={colInfos}
                            tableData={data}
                            serverErrors={serverErrors}
                            onCellChange={onCellChange}
                        />
                    </Popup.Body>
                    <Popup.Footer>
                        <Authorize applicationFunction={ApplicationFunctions.UpdateItemRevision} itemTypeId={itemTypeId}>
                            <SaveButton onClick={SaveChanges} />
                        </Authorize>
                    </Popup.Footer>
                </Popup>
                {showSpinner && <SpinnerOverlay />}
            </>
        )
    }

    return null;
}
export default ItemRevision_popup_EditItemSizes;
